var localStorage = null;
var storagePrefix = 'portal-';

// In order of preference, use localStorage, sessionStorage or a plain in-memory object.
// This is mostly to work around Safari private browsing not supporting localStorage.

if (doesStorageWork(window.localStorage)) {
    localStorage = window.localStorage;
} else if (doesStorageWork(window.sessionStorage)) {
    localStorage = window.sessionStorage;
} else {
    localStorage = {};
}

function makeStorageKey(key) {
    return storagePrefix + key;
}

module.exports = {
    clear: function () {
        localStorage.clear();
    },
    get: function (key) {
        return JSON.parse(this.getRaw(key));
    },
    getRaw: function (key) {
        return localStorage[makeStorageKey(key)] || null;
    },
    has: function (key) {
        return localStorage.hasOwnProperty(makeStorageKey(key));
    },
    set: function (key, value) {
        this.setRaw(key, JSON.stringify(value));
    },
    setRaw: function (key, value) {
        localStorage[makeStorageKey(key)] = value;
    },
    unset: function (key) {
        var storageKey = makeStorageKey(key);

        if (localStorage.removeItem) {
            localStorage.removeItem(storageKey);
        } else {
            delete localStorage[storageKey];
        }
    }
};

function doesStorageWork(storage) {
    if (!storage) {
        return false;
    }

    try {
        storage['_teststorage'] = 1;
        storage.removeItem('_teststorage');

        return true;
    } catch (error) {
        return false;
    }
}



// WEBPACK FOOTER //
// ./app/util/LocalStorage.js